export const AUTH_CONSTANT = {
  JWT: 'JWT',
}

